import { defs as dtsServerDefs, dtsServer } from './dtsServer';

(window as any).defs = {
  dtsServer: dtsServerDefs,
};
(window as any).API = {
  dtsServer,
};
